// eslint-disable-next-line import/no-unresolved
import Keycloak from 'keycloak-js';

// Em `npm start` o .env pode apontar para outro realm (ver .env.example). O build usa sempre o de
// produção, mesmo que exista um .env na máquina que gera o build.
const dev = process.env.NODE_ENV === 'development';

const keycloakConfig = {
    url: (dev && process.env.REACT_APP_KEYCLOAK_URL) || 'https://sso.cleversystems.com.br',
    realm: (dev && process.env.REACT_APP_KEYCLOAK_REALM) || 'DASHBOARD_PRODUCAO',
    clientId: (dev && process.env.REACT_APP_KEYCLOAK_CLIENT_ID) || 'dashboard-front',
};

const keycloak = new Keycloak(keycloakConfig);

export default keycloak;